









import VueOptions from '@utils/VueOptions'
import FormBuilder from '@ui/FormBuilder/FormBuilder'
import CreativeFields from '@ui/FormBuilder/ResourceFields/CreativeFields.coffee'

settings =
  name: 'AdvancedSettingsForm'

  vue:
    props: ['form']

    components: {
      FormBuilder,
    }

    computed:
      segments: ->
        segments = []
        for availability in @form.data.availabilities
          segments.push ...availability.audience_listing.segments
        Array.from(new Set(segments))

      contextForCreativeFields: ->
        options:
          preferred_brand_categories: @toSelectOptions(@$store.marketplace?.brand?.categories)
          sponsor_primary_domains: [...@form.data.sponsor_set]

      creativeFields: ->
        CreativeFields(@contextForCreativeFields)

export default VueOptions.vue settings
